import React, { useEffect, useState } from "react";
import { SliderWidgetScene } from "@learningblocks/widgets/slider-widget-components";
import i18next from "i18next";

export function SliderWidgetContainer(props) {
  const lang = i18next.language;
  const [sceneData, setSceneData] = useState("");
  const [animationData, setAnimationData] = useState("");
  const [mobileAnimationData, setMobileAnimationData] = useState("");
  const [translationData, setTranslationData] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (sceneData !== "" && animationData !== "" && translationData !== "") {
      setReady(true);
    }
  }, [sceneData, animationData, translationData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(
      window.location.origin +
        window.location.pathname +
        `sliderScene-${props.name}.json`
    )
      .then((response) => response.json())
      .then((data) => {
        setSceneData(data);
      });
    fetch(
      window.location.origin +
        window.location.pathname +
        `locales/${lang}/sliderAnimation-${props.name}.json`
    )
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          window.location.origin +
            window.location.pathname +
            `locales/en/sliderAnimation-${props.name}.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setAnimationData(data);
          });
        throw error;
      })
      .then((data) => {
        setAnimationData(data);
      });
    fetch(
      window.location.origin +
        window.location.pathname +
        `locales/${lang}/sliderAnimation-${props.name}_mobile.json`
    )
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          window.location.origin +
            window.location.pathname +
            `locales/en/sliderAnimation-${props.name}_mobile.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setMobileAnimationData(data);
          });
        throw error;
      })
      .then((data) => {
        setMobileAnimationData(data);
      });
    fetch(
      window.location.origin +
        window.location.pathname +
        `locales/${lang}/sliderTranslation-${props.name}.json`
    ) // Should be "lang" instead of ""en"", but lang currently causes a crash because we do not yet create the files needed.
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          window.location.origin +
            window.location.pathname +
            `locales/en/sliderTranslation-${props.name}.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setTranslationData(data);
          });
        throw error;
      })
      .then((data) => {
        setTranslationData(data);
      });
  };

  return (
    <div
      className="sliderWidget-container"
      style={{
        marginBottom: "16px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        border: "1px solid",
        padding: "24px",
      }}
    >
      <h6
        style={{
          fontFamily: "Bio Sans, sans-serif",
          color: "#333333",
          fontSize: "14px",
          letterSpacing: "1px",
          textTransform: "uppercase",
          margin: "0px",
          marginBottom: "8px",
        }}
      >
        Explore
      </h6>
      {ready === true ? (
        <SliderWidgetScene
          animationData={animationData}
          mobileAnimationData={
            mobileAnimationData === "" ? null : mobileAnimationData
          }
          sceneData={sceneData}
          stringData={translationData}
          allowOverflow={true}
          path={props.name}
          lang={lang}
          standalone={false}
        />
      ) : null}
    </div>
  );
}
